/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ContainerShippingMethod;
(function (ContainerShippingMethod) {
    let vessel_type;
    (function (vessel_type) {
        vessel_type["CONTAINER_SHIP"] = "container_ship";
    })(vessel_type = ContainerShippingMethod.vessel_type || (ContainerShippingMethod.vessel_type = {}));
    /**
     * Container transport emissions vary per trade lane. When a trade lane is not given we'll
     * use an industry-wide average. Providing an `aggregated_*` trade lane group will result in an
     * a more accurate estimate. Providing an `disaggregated_*` trade lane will result in the best
     * estimate precision.
     *
     * The identifiers are kept relatively short for brevity: Mediterranean includes Black Sea and
     * South America includes Central America.
     *
     * The trade lanes are bidirectional, for example `disaggregated_asia_to_africa` covers both
     * Asia to Africa and Africa to Asia.
     *
     */
    let trade_lane;
    (function (trade_lane) {
        trade_lane["AGGREGATED_PANAMA_TRADE"] = "aggregated_panama_trade";
        trade_lane["AGGREGATED_TRANSATLANTIC"] = "aggregated_transatlantic";
        trade_lane["AGGREGATED_TRANSSUEZ"] = "aggregated_transsuez";
        trade_lane["AGGREGATED_TRANSPACIFIC"] = "aggregated_transpacific";
        trade_lane["AGGREGATED_OTHER"] = "aggregated_other";
        trade_lane["DISAGGREGATED_ASIA_TO_AFRICA"] = "disaggregated_asia_to_africa";
        trade_lane["DISAGGREGATED_ASIA_TO_MEDITERRANEAN"] = "disaggregated_asia_to_mediterranean";
        trade_lane["DISAGGREGATED_ASIA_TO_MIDDLE_EAST"] = "disaggregated_asia_to_middle_east";
        trade_lane["DISAGGREGATED_ASIA_TO_NORTH_AMERICA_EAST"] = "disaggregated_asia_to_north_america_east";
        trade_lane["DISAGGREGATED_ASIA_TO_NORTH_AMERICA_WEST"] = "disaggregated_asia_to_north_america_west";
        trade_lane["DISAGGREGATED_ASIA_TO_NORTH_EUROPE"] = "disaggregated_asia_to_north_europe";
        trade_lane["DISAGGREGATED_ASIA_TO_OCEANIA"] = "disaggregated_asia_to_oceania";
        trade_lane["DISAGGREGATED_ASIA_TO_SOUTH_AMERICA"] = "disaggregated_asia_to_south_america";
        trade_lane["DISAGGREGATED_EUROPE_TO_AFRICA"] = "disaggregated_europe_to_africa";
        trade_lane["DISAGGREGATED_EUROPE_TO_SOUTH_AMERICA"] = "disaggregated_europe_to_south_america";
        trade_lane["DISAGGREGATED_EUROPE_TO_MIDDLE_EAST"] = "disaggregated_europe_to_middle_east";
        trade_lane["DISAGGREGATED_EUROPE_TO_OCEANIA"] = "disaggregated_europe_to_oceania";
        trade_lane["DISAGGREGATED_MEDITERRANEAN_TO_NORTH_AMERICA_EAST"] = "disaggregated_mediterranean_to_north_america_east";
        trade_lane["DISAGGREGATED_MEDITERRANEAN_TO_NORTH_AMERICA_WEST"] = "disaggregated_mediterranean_to_north_america_west";
        trade_lane["DISAGGREGATED_NORTH_AMERICA_TO_AFRICA"] = "disaggregated_north_america_to_africa";
        trade_lane["DISAGGREGATED_NORTH_AMERICA_TO_OCEANIA"] = "disaggregated_north_america_to_oceania";
        trade_lane["DISAGGREGATED_NORTH_AMERICA_TO_SOUTH_AMERICA"] = "disaggregated_north_america_to_south_america";
        trade_lane["DISAGGREGATED_NORTH_AMERICA_TO_MIDDLE_EAST"] = "disaggregated_north_america_to_middle_east";
        trade_lane["DISAGGREGATED_NORTH_EUROPE_TO_NORTH_AMERICA_EAST"] = "disaggregated_north_europe_to_north_america_east";
        trade_lane["DISAGGREGATED_NORTH_EUROPE_TO_NORTH_AMERICA_WEST"] = "disaggregated_north_europe_to_north_america_west";
        trade_lane["DISAGGREGATED_SOUTH_AMERICA_TO_AFRICA"] = "disaggregated_south_america_to_africa";
        trade_lane["DISAGGREGATED_INTRA_AFRICA"] = "disaggregated_intra_africa";
        trade_lane["DISAGGREGATED_INTRA_NORTH_AMERICA"] = "disaggregated_intra_north_america";
        trade_lane["DISAGGREGATED_INTRA_SOUTH_AMERICA"] = "disaggregated_intra_south_america";
        trade_lane["DISAGGREGATED_SE_ASIA_TO_NE_ASIA"] = "disaggregated_se_asia_to_ne_asia";
        trade_lane["DISAGGREGATED_INTRA_NE_ASIA"] = "disaggregated_intra_ne_asia";
        trade_lane["DISAGGREGATED_INTRA_SE_ASIA"] = "disaggregated_intra_se_asia";
        trade_lane["DISAGGREGATED_NORTH_EUROPE_TO_MEDITERRANEAN"] = "disaggregated_north_europe_to_mediterranean";
        trade_lane["DISAGGREGATED_INTRA_MEDITERRANEAN"] = "disaggregated_intra_mediterranean";
        trade_lane["DISAGGREGATED_INTRA_NORTH_EUROPE"] = "disaggregated_intra_north_europe";
        trade_lane["DISAGGREGATED_INTRA_MIDDLE_EAST"] = "disaggregated_intra_middle_east";
        trade_lane["DISAGGREGATED_OTHER"] = "disaggregated_other";
    })(trade_lane = ContainerShippingMethod.trade_lane || (ContainerShippingMethod.trade_lane = {}));
})(ContainerShippingMethod || (ContainerShippingMethod = {}));
//# sourceMappingURL=ContainerShippingMethod.js.map